import Vue from 'vue'
import VueRouter from 'vue-router'
import SetupProject from '../views/setupProject/SetupProject.vue'
import ViewRules from '../views/viewRules/ViewRules.vue'
import ViewScale from '../views/viewScale/ViewScale.vue'
import ViewEmployee from '../views/viewEmployee/ViewEmployee'
import viewUnionLocations from '../views/viewUnionLocations/viewUnionLocations'
import Home from '../views/home/Home.vue'

Vue.use(VueRouter)

const routes = [
    // Need this route to get the ID of the payroll
    {
        path: '*/viewUnionLocations',
        name: 'Union',
        component: viewUnionLocations,
    },
    {
        path: '*/viewEmployee',
        name: 'Employee',
        component: ViewEmployee,
    },
    {
        path: '*/setupProject',
        name: 'Setup',
        component: SetupProject,
    },
    {
        path: '*/viewScale',
        name: 'Scale',
        component: ViewScale,
    },
    {
        path: '*/viewRules',
        name: 'Rules',
        component: ViewRules,
    },
    {
        path: '/',
        name: 'Home',
        component: Home,
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
})

export default router
